<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xObG0h/tc-custom/9781468302929.jpg?1734334786214" alt="This image is the cover for the book Full Catastrophe"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Full Catastrophe
      </h1>
      <p class="bookDescription body article font2">
        <b>A New York Times Notable Book: “A comic chronicle of marital misunderstandings . . . Eccentric, hilarious, wildly inventive” (<i>Los Angeles Times</i>).</b><br/>  <br/> Linguist Jeremy Cook knows how language works, but he doesn’t know how marriage works. In fact, he is strangely hostile to the institution. So Cook is naturally uneasy about his job with a St. Louis firm specializing in “the linguistically troubled marriage.”<br/>  <br/> His assignment is to move in with Dan and Beth Wilson, a prosperous suburban couple with an impoverished relationship, to analyze their problems with verbal communication and help them—if he can. But as Cook catalogs the Wilsons’ missed signs and signals, he becomes increasingly, and unscientifically, involved . . .<br/>  <br/> “Read this terrific book.” —<i>Los Angeles Times</i><br/>  <br/> “With humor and insight, Mr. Carkeet’s fourth novel addresses the commonest of social diseases—a failing marriage—with the least likely of therapies: a live-in linguist.” —<i>The New York Times Book Review</i><br/>  <br/> “Carkeet’s premise is fresh, his characters utterly winning and his comic observations full of affection for those caught up in the complex confusions of love. Laugh-out-loud scenes and swift, convincing dialogue.” —<i>Publishers Weekly</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Carkeet
      </h2>
      
      <p class="authorDescription body article">David Carkeet was born and raised in the Gold Rush town of Sonora, California. He went to college at U.C. Davis and Berkeley, then to graduate school at U. of Wisconsin and Indiana U.&mdash;thus the southern Indiana setting for <I>Double Negative</I>,&#160;his first novel. He lived in St. Louis for thirty years, where he set <I>The Full Catastrophe</I>&#160;and <I>The Error of Our Ways</I>.&#160;He now lives near Montpelier, Vermont, and you can probably guess where he set his newest novel, <I>From Away</I>.&#160;He is married with three grown daughters. More info at davidcarkeet.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The Overlook Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6ade0271